import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api';
import GateAccessManager from './GateAccessManager';
import { QRCodeCanvas } from 'qrcode.react';




// Form for creating a new logical Gate
function CreateGateForm({ locationId, onGateCreated, onCancel }) {
  const [name, setName] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGetPosition = () => {
    if (!navigator.geolocation) {
      alert('Geolokasjon støttes ikke av denne nettleseren.');
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        setLoading(false);
      },
      (err) => {
        alert('Kunne ikke hente posisjon: ' + err.message);
        setLoading(false);
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await callApi('createGateV2', { 
        locationId, 
        name,
        latitude: latitude ? parseFloat(latitude) : null,
        longitude: longitude ? parseFloat(longitude) : null
      });
      if (onGateCreated) onGateCreated();
    } catch (err) {
      setError('Kunne ikke opprette port: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '5px', margin: '20px auto', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
      <h4>Opprett Ny Port</h4>
      <div>
        <label htmlFor="create-gate-name" style={{ display: 'block', marginBottom: '5px' }}>Navn (f.eks. Inngang A)</label>
        <input id="create-gate-name" value={name} onChange={e => setName(e.target.value)} required style={{ width: '100%' }} />
      </div>
      
      <div style={{ display: 'flex', gap: '10px' }}>
          <div style={{ flex: 1 }}>
            <label htmlFor="gate-lat" style={{ display: 'block', marginBottom: '5px' }}>Breddegrad (Lat)</label>
            <input id="gate-lat" type="number" step="any" value={latitude} onChange={e => setLatitude(e.target.value)} style={{ width: '100%' }} />
          </div>
          <div style={{ flex: 1 }}>
            <label htmlFor="gate-long" style={{ display: 'block', marginBottom: '5px' }}>Lengdegrad (Long)</label>
            <input id="gate-long" type="number" step="any" value={longitude} onChange={e => setLongitude(e.target.value)} style={{ width: '100%' }} />
          </div>
      </div>
      <button type="button" onClick={handleGetPosition} style={{ alignSelf: 'flex-start', fontSize: '0.8em' }}>📍 Hent min posisjon</button>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <button type="button" onClick={onCancel}>Avbryt</button>
        <button type="submit" disabled={loading}>{loading ? 'Oppretter...' : 'Opprett Port'}</button>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
}

// Form for editing a Gate
function EditGateForm({ gate, onFinished }) {
    const [name, setName] = useState(gate.name || '');
    const [latitude, setLatitude] = useState(gate.latitude || '');
    const [longitude, setLongitude] = useState(gate.longitude || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleGetPosition = () => {
        if (!navigator.geolocation) {
          alert('Geolokasjon støttes ikke av denne nettleseren.');
          return;
        }
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
            setLoading(false);
          },
          (err) => {
            alert('Kunne ikke hente posisjon: ' + err.message);
            setLoading(false);
          }
        );
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            await callApi('updateGateV2', { 
                gateId: gate.id, 
                name,
                latitude: latitude ? parseFloat(latitude) : null,
                longitude: longitude ? parseFloat(longitude) : null
            });
            if (onFinished) onFinished();
        } catch (err) {
            setError('Kunne ikke oppdatere port: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (window.confirm(`Er du sikker på at du vil slette porten "${gate.name}"? Dette kan ikke angres.`)) {
            setLoading(true);
            setError(null);
            try {
                await callApi('deleteGateV2', { gateId: gate.id });
                if (onFinished) onFinished();
            } catch (err) {
                setError('Kunne ikke slette port: ' + err.message);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <form onSubmit={handleUpdate} style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', display: 'flex', flexDirection: 'column', gap: '15px', minWidth: '350px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
                <h4>Rediger Port</h4>
                <div>
                  <label htmlFor="edit-gate-name" style={{ display: 'block', marginBottom: '5px' }}>Navn på port</label>
                  <input id="edit-gate-name" value={name} onChange={e => setName(e.target.value)} required style={{ width: '100%' }} />
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="edit-gate-lat" style={{ display: 'block', marginBottom: '5px' }}>Breddegrad (Lat)</label>
                        <input id="edit-gate-lat" type="number" step="any" value={latitude} onChange={e => setLatitude(e.target.value)} style={{ width: '100%' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="edit-gate-long" style={{ display: 'block', marginBottom: '5px' }}>Lengdegrad (Long)</label>
                        <input id="edit-gate-long" type="number" step="any" value={longitude} onChange={e => setLongitude(e.target.value)} style={{ width: '100%' }} />
                    </div>
                </div>
                <button type="button" onClick={handleGetPosition} style={{ alignSelf: 'flex-start', fontSize: '0.8em' }}>📍 Hent min posisjon</button>

                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <button type="button" onClick={handleDelete} disabled={loading} style={{backgroundColor: 'var(--danger-color)'}}>Slett</button>
                    <div>
                        <button type="button" onClick={onFinished} style={{marginRight: '10px'}}>Avbryt</button>
                        <button type="submit" disabled={loading}>{loading ? 'Lagrer...' : 'Lagre'}</button>
                    </div>
                </div>
            </form>
        </div>
    );
}

// Form for assigning a physical device to a gate
function AssignDeviceForm({ gate, allDevices, onFinished }) {
    const [selectedDeviceId, setSelectedDeviceId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const availableDevices = allDevices.filter(d => d.status === 'unassigned' || d.id === gate.assignedDeviceId);

    useEffect(() => {
        if (gate.assignedDeviceId) {
            setSelectedDeviceId(gate.assignedDeviceId);
        }
    }, [gate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedDeviceId) {
            setError('Du må velge en enhet.');
            return;
        }
        setLoading(true);
        setError(null);
        try {
            await callApi('assignDeviceToGateV2', { gateId: gate.id, deviceId: selectedDeviceId });
            if (onFinished) onFinished();
        } catch (err) {
            setError('Kunne ikke koble til enhet: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <form onSubmit={handleSubmit} style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', display: 'flex', flexDirection: 'column', gap: '15px', minWidth: '350px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
                <h4>Koble enhet til port: {gate.name}</h4>
                <select value={selectedDeviceId} onChange={e => setSelectedDeviceId(e.target.value)} required>
                    <option value="">Velg en fysisk enhet (serienr)</option>
                    {availableDevices.map(dev => (
                        <option key={dev.id} value={dev.id}>{`${dev.id} (${dev.model || 'Ukjent modell'})`}</option>
                    ))}
                </select>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button type="button" onClick={onFinished}>Avbryt</button>
                    <button type="submit" disabled={loading}>{loading ? 'Lagrer...' : 'Koble til'}</button>
                </div>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </form>
        </div>
    );
}


function GatesDashboard({ location, onDrillDown, onBack }) {
  const [gates, setGates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingGate, setEditingGate] = useState(null);
  const [assigningToGate, setAssigningToGate] = useState(null);
  const [managingAccessForGate, setManagingAccessForGate] = useState(null);
  const [showingQrCodeForGate, setShowingQrCodeForGate] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // New state and logic for fetching devices
  const [allDevices, setAllDevices] = useState([]);
  const [devicesLoading, setDevicesLoading] = useState(true);

  const fetchAllDevices = useCallback(async () => {
    setDevicesLoading(true);
    try {
      const result = await callApi('listAllDevicesV2');
      setAllDevices(result.devices);
    } catch (error) {
      setError("Kunne ikke laste enheter: " + error.message);
    } finally {
      setDevicesLoading(false);
    }
  }, []);


  const fetchGates = useCallback(async () => {
    if (!location?.id) return;
    setLoading(true);
    setError(null);
    try {
      const gatesResult = await callApi('listGatesByLocationV2', { locationId: location.id });
      setGates(gatesResult.gates);
    } catch (err) {
      setError('Kunne ikke hente data. ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [location.id]);

  useEffect(() => {
    fetchGates();
    fetchAllDevices();
  }, [fetchGates, fetchAllDevices]);

  const handleFormFinished = () => {
    setShowCreateForm(false);
    setAssigningToGate(null);
    setManagingAccessForGate(null);
    setEditingGate(null);
    fetchGates();
    fetchAllDevices(); // Refetch the global device list
  };





  return (
    <div>
      <button onClick={onBack}>&larr; Tilbake til Lokasjoner</button>
      <h2>Porter for {location.name}</h2>
      
      {!showCreateForm && !assigningToGate && !managingAccessForGate && !editingGate && (
        <button onClick={() => setShowCreateForm(true)} style={{ margin: '20px 0' }}>
          + Opprett Ny Port
        </button>
      )}

      {showCreateForm && (
        <CreateGateForm
          locationId={location.id}
          onGateCreated={handleFormFinished}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      {editingGate && (
        <EditGateForm gate={editingGate} onFinished={handleFormFinished} />
      )}

      {assigningToGate && (
          <AssignDeviceForm 
            gate={assigningToGate}
            allDevices={allDevices}
            onFinished={handleFormFinished}
          />
      )}

      {managingAccessForGate && (
        <GateAccessManager 
            gate={managingAccessForGate}
            ownerId={location.ownerId}
            onFinished={handleFormFinished}
        />
      )}

      {showingQrCodeForGate && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', display: 'flex', flexDirection: 'column', gap: '15px', minWidth: '300px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
            <h4>QR-kode for {showingQrCodeForGate.name}</h4>
            <div id="qr-code-print-area" style={{ display: 'flex', justifyContent: 'center', padding: '20px', background: 'white' }}>
              <QRCodeCanvas value={`https://bifrostkey.com/request-access?gateId=${showingQrCodeForGate.id}`} size={256} level="H" includeMargin={true} />
            </div>
            <p style={{ textAlign: 'center', fontSize: '0.8em', color: 'var(--text-dark)' }}>Skann denne koden for å be om tilgang til porten.</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <button onClick={() => setShowingQrCodeForGate(null)}>Lukk</button>
              <button onClick={() => window.print()}>Skriv ut</button>
            </div>
          </div>
        </div>
      )}

      <h3>Registrerte Porter</h3>
      {(loading || devicesLoading) && <p>Laster...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !devicesLoading && !error && (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Portnavn</th>
              {!isMobile && <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Tilkoblet Enhet (Serienr.)</th>}
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', width: '1%', whiteSpace: 'nowrap' }}>Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {gates.map(gate => (
              <tr key={gate.id}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{gate.name}</td>
                {!isMobile && <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    {gate.assignedDeviceId ? gate.assignedDeviceId : <em>Ikke tilkoblet</em>}
                </td>}
                <td style={{ border: '1px solid #ddd', padding: '8px', width: '1%', whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => setEditingGate(gate)}>Rediger</button>
                    <button onClick={() => setAssigningToGate(gate)}>
                      {gate.assignedDeviceId ? 'Bytt enhet' : 'Koble til enhet'}
                    </button>
                    <button onClick={() => setManagingAccessForGate(gate)}>Administrer Tilgang</button>
                    <button onClick={() => setShowingQrCodeForGate(gate)}>Vis QR-kode</button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}


    </div>
  );
}

export default GatesDashboard;
